// extracted by mini-css-extract-plugin
module.exports = {"profile__dots":"AccountSettings_profile__dots__3xPEt"};